module.exports = __webpack_public_path__ + "static/media/next.5af5ffca.svg";